export default String.raw`
@media (min-width: 769px) and (max-width: 1024px) {
    .sitemap-sections {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1025px) {
    .sitemap-sections {
        grid-template-columns: repeat(4, 1fr);
    }
}
`